import {Component, inject, input, OnInit} from '@angular/core'
import {FormGroup, ReactiveFormsModule, Validators} from '@angular/forms'
import {MatCheckbox} from '@angular/material/checkbox'
import {MatError, MatFormField, MatLabel, MatSuffix} from '@angular/material/form-field'
import {MatIcon} from '@angular/material/icon'
import {MatInput} from '@angular/material/input'
import {MatRadioButton, MatRadioGroup} from '@angular/material/radio'
import {MatOption, MatSelect} from '@angular/material/select'
import {SPBConstants} from '@sparbanken-syd/sparbanken-syd-theme'
import {OrientationService} from '../../../services/orientation.service'
import {FormUtils} from '../../../utils/form.utils'

export const pepStatus = [
  {value: 'notPep', label: 'Nej, jag är inte PEP eller RCA'},
  {
    value: 'pep',
    label: 'Ja, jag är eller har de senaste 18 månaderna varit en person i politiskt utsatt ställning'
  },
  {
    value: 'rca',
    label: 'Ja, jag är anhörig alternativt nära medarbetare till någon som är, eller de senaste 18 månaderna varit, en person i politiskt utsatt ställning (RCA)'
  }
]

export const pepTitles = [
  {
    value: 'headOfGovernment',
    label: 'Stats-, eller regeringschef, minister eller biträdande minister'
  },
  {
    value: 'parliamentMember',
    label: 'Riksdagsledamot/Parlamentsledamot eller ledamot i centralbankens styrande organ'
  },
  {
    value: 'politicalPartyBoardMember',
    label: 'Ledamot i styrelse för politiskt parti'
  },
  {
    value: 'judgeOrLegalOfficial',
    label: 'Domare i Högsta domstolen, konstitutionell domstol eller annat rättsligt organ'
  },
  {
    value: 'governmentAuditor',
    label: 'Hög tjänsteman vid revisionsmyndighet'
  },
  {value: 'ambassadorOrEnvoy', label: 'Ambassadör eller beskickningschef'},
  {
    value: 'seniorMilitaryOfficer',
    label: 'Hög officerare inom Försvarsmakten'
  },
  {
    value: 'stateOwnedCompanyDirector',
    label: 'VD eller styrelseledamot i ett statsägt företag'
  },
  {
    value: 'internationalOrganizationLeader',
    label: 'Ledande befattning i en internationell organisation'
  }
]

export const rcaRelations = [
  {value: 'spouse', label: 'Make/maka'},
  {value: 'registeredPartner', label: 'Registrerad partner'},
  {value: 'cohabitant', label: 'Sambo'},
  {value: 'child', label: 'Barn'},
  {
    value: 'childSpouseCohabitant',
    label: 'Barns make/maka, sambo, registrerad partner är en PEP'
  },
  {value: 'parent', label: 'Förälder'},
  {value: 'knownCloseAssociate', label: 'Känd/Nära medarbetare'},
  {
    value: 'closeBusinessAssociate',
    label: 'Nära affärsförbindelse eller bestämmande inflytande i ett företag som ägs eller har bildats till förmån för en PEP'
  }
]

@Component({
  selector: 'spb-pep',
  templateUrl: './pep.component.html',
  styleUrl: '../kyc.component.scss',
  imports: [ReactiveFormsModule, MatRadioGroup, MatRadioButton, MatCheckbox, MatFormField, MatSuffix, MatLabel, MatInput, MatSelect, MatOption, MatError, MatIcon]
})
export class PepComponent implements OnInit {
  public pepForm = input.required<FormGroup>()
  public validatePepYouStatus = false
  public validatePepOtherStatus = false

  protected rcaRelationText = 'Vänligen specificera arbetstitel, befattning, organisation, relation samt land till ytterligare personer i politiskt utsatt ställning'

  protected pepRelationText = 'Vänligen specificera arbetstitel, befattning, organisation, relation samt land till personen i politiskt utsatt ställning'

  protected pepWorkText = 'Vänligen specificera arbetstitel, befattning, organisation och land för dina ytterligare arbete i politiskt utsatt ställning'

  protected pepStatus = pepStatus
  protected pepTitles = pepTitles
  protected rcaRelations = rcaRelations
  protected readonly countryList = SPBConstants.CountryList

  protected readonly orientationService = inject(OrientationService)

  public onCheckboxChange(value: string, control: string, checked: boolean) {
    if (checked) {
      this.validatePepYouStatus = false
      this.pepForm().patchValue({[control]: value})
    } else {
      this.pepForm().patchValue({[control]: null})
    }
  }

  public ngOnInit() {
    this.pepForm().controls.pepStatus.valueChanges
      .subscribe(
        status => {
          let list: string[] = ['pepTitle', 'pepPosition', 'pepCountry', 'pepRelation']
          const controls = this.pepForm().controls
          /**
           * Reset controls and remove validators when we change status
           */
          list.forEach(l => {
            controls[l].reset()
            FormUtils.addOrRemoveValidation(false, controls[l], [Validators.required])
          })

          /**
           * Add controls in different scenarios
           */
          if (status === 'rca') {
            list = ['pepTitle', 'pepPosition', 'pepCountry', 'pepRelation']
            list.forEach(l => {
              FormUtils.addOrRemoveValidation(true, controls[l], [Validators.required])
            })
          } else if (status === 'pep') {
            list = ['pepTitle', 'pepPosition', 'pepCountry']
            list.forEach(l => {
              FormUtils.addOrRemoveValidation(true, controls[l], [Validators.required])
            })
          }
        }
      )
  }
}
